export const getDropTargetStyle = (
  translateX: number,
  translateY: number
): React.CSSProperties => ({
  transition: 'transform 0.3s',
  transform: `translate3d(${translateX}px, ${translateY}px, 0)`,
});
